import { BottomSheet } from '@interco/inter-ui/components/BottomSheet'
import { Button } from '@interco/inter-ui/components/Button'
import { Text } from '@interco/inter-ui/components/Text'
import { useTrackingRefin } from '@hooks'
import { StepRefin } from '@utils/enums'

import { listaAutorizacaoPortal } from '../types'
import { useSiapeAuthorizationSheet } from '../useSiapeAuthorizationSheet'
import { Buttons, Container, Header, Item, List, Number } from './styles'

interface FirstAttemptBottomSheetProps {
  onDismiss: () => void
  onConfirmAuthorization: () => void
  onRetryMarginResult: () => void
}

export const FirstAttemptBottomSheet = ({
  onDismiss,
  onConfirmAuthorization,
  onRetryMarginResult,
}: FirstAttemptBottomSheetProps) => {
  useTrackingRefin(StepRefin.CONSULTA_MARGEM_PRIMEIRA_TENTATIVA)

  const { handleAccessSouGov, handleConfirmAuthorization } = useSiapeAuthorizationSheet({
    attempt: 'first',
    onConfirmAuthorization,
    onRetryMarginResult,
  })

  return (
    <BottomSheet onClose={onDismiss} noSwipe>
      <Container>
        <Header>
          <Text variant="body-2" bold colorWeight={500}>
            Não foi possível consultar a margem
          </Text>
          <Text variant="body-3">
            Pra simular seu empréstimo, precisamos que você autorize a consulta de margem.
          </Text>
        </Header>
        <List>
          {listaAutorizacaoPortal.map(({ code, description }) => (
            <Item key={code}>
              <Number aria-hidden="true">{code}</Number>
              <Text variant="body-3">{description}</Text>
            </Item>
          ))}
        </List>
      </Container>
      <Buttons>
        <Button fullWidth onClick={handleAccessSouGov}>
          Acessar SouGov
        </Button>
        <Button fullWidth variant="secondary" onClick={handleConfirmAuthorization}>
          Já autorizei
        </Button>
      </Buttons>
    </BottomSheet>
  )
}
